var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurvearrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 47,
    viewBox: "0 0 73 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1259_348102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.10002 13.5502C8.30002 7.65021 16.2 4.15021 24.9 4.95021C29.7 5.35021 33.5 6.65021 34.5 11.9502C35.1 15.5502 35 19.2502 36.1 22.6502C38 28.2502 42.9 31.7502 48.7 32.5502C56.2 33.6502 63.2 29.9502 69.5 26.3502C72.4 24.7502 69.8 20.3502 66.9 21.9502C59.9 25.6502 46.2 32.3502 41.1 22.1502C38.2 16.5502 40.6 7.85021 34.9 3.55021C30.3 0.150211 22.4 0.450211 17.1 1.55021C10.5 3.05021 4.50002 6.55021 0.30002 11.7502C-0.69998 12.9502 0.90002 14.6502 2.10002 13.5502Z",
    fill: "#666666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.2 21.1501C55.3 24.3501 62.6 24.9501 70.3 24.1501C69.7 23.1501 69.1 22.0501 68.5 21.0501C66.4 25.2501 62.6 27.8501 59.8 31.6501C57 35.3501 54.8 39.4501 53.1 43.7501C52.3 45.8501 55.5 47.0501 56.6 45.2501C59.2 40.8501 61.2 36.2501 64.7 32.3501C67.4 29.3501 70.2 26.8501 71.9 23.1501C72.5 21.9501 71.8 19.8501 70.1 20.0501C63 20.9501 55.9 20.3501 48.8 19.2501C47.9 19.1501 47 20.6501 48.2 21.1501Z",
    fill: "#666666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.90001 12.3501C14.3 10.5501 22.5 6.55015 27.7 10.3501C28.5 10.9501 29.3 9.55015 28.5 8.95015C22.8 4.85015 13.8 8.45015 8.60001 11.7501C8.30001 11.9501 8.50001 12.4501 8.90001 12.3501Z",
    fill: "#666666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30.3 12.8501C31.7 12.8501 31.7 10.6501 30.3 10.6501C28.9 10.6501 28.9 12.8501 30.3 12.8501Z",
    fill: "#666666"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1259_348102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.2,
    height: 45.3,
    fill: "white",
    transform: "translate(0 0.850098)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvearrow);
export default __webpack_public_path__ + "static/media/curvearrow.d0a7bf6469a3daf69632002806a3c5bd.svg";
export { ForwardRef as ReactComponent };